import NotFound from "@/views/error/NotFound.vue";
import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";

export default [
  {path: "/", component: Home},
  {path: "/home", component: Home},
  {path: "/login", component: Login},
  {path: "/404", component: NotFound},
  {path: "/*", component: NotFound}
];
